import { io, Socket } from 'socket.io-client'
import appConfig from '../../../config'
import { newTeloSocketConnector } from '../teloSocketConnector'
import { ExamIdData, TeloSocket, UpdateWorklistFn } from '../teloSocketTypes'
import {
	basicDisconnectSocket,
	checkOrigin,
	isSocketConnected,
} from '../teloSocketUtils'

type DoctorExamsInStoreSocketArgs = {
	storeId: string
	doctorUsername: string
	sessionId: string
	updateWorklist: UpdateWorklistFn
}

const newSocket = ({
	doctorUsername,
	storeId,
	updateWorklist,
	sessionId,
}: DoctorExamsInStoreSocketArgs): TeloSocket => {
	let socket: Socket | null = null

	const connect = (): void => {
		if (isSocketConnected(socket)) {
			return
		}

		socket = io(appConfig.socketUrl, {
			query: { storesId: storeId, doctorUsername },
			transports: ['websocket'],
		})

		socket.on('doctor-exams-update-available', (data: ExamIdData) => {
			onDoctorExamsUpdateAvailableMessage({ data, sessionId, updateWorklist })
		})
	}

	const disconnect = () => {
		basicDisconnectSocket(socket)
		socket = null
	}

	return { connect, disconnect }
}

type DoctorExamsUpdateAvailableMessageArgs = {
	data: ExamIdData
	sessionId: string
	updateWorklist: UpdateWorklistFn
}

const onDoctorExamsUpdateAvailableMessage = (
	args: DoctorExamsUpdateAvailableMessageArgs,
): void => {
	const { data, sessionId, updateWorklist } = args
	const sameOrigin = checkOrigin(sessionId, data)
	if (sameOrigin === true) {
		return
	}

	updateWorklist()
}

const socketConnector = newTeloSocketConnector()

export function connectToSocketDoctorStore(
	args: DoctorExamsInStoreSocketArgs,
): void {
	socketConnector.connectSocket({
		socketKey: getSocketKey(args),
		newSocket: () => newSocket(args),
	})
}

type DoctorStoreKey = {
	storeId: string
	doctorUsername: string
}

const getSocketKey = ({ doctorUsername, storeId }: DoctorStoreKey): string => {
	const key: DoctorStoreKey = { doctorUsername, storeId }
	return JSON.stringify(key)
}
